import useAccessControls from 'modules/access-controls/atoms/use-access-controls';

const useInitialPage = () => {
  const {isAllowed} = useAccessControls();

  if (isAllowed('orders.findAll')) return '/orders';

  return '/profile';
};

export default useInitialPage;
